/// <reference path="../types/index.d.ts" />

import '../client_forms/fareextra/style.css';
import FormStructure from './fareextra/form_structure';

export default FormStructure;